import AOS from "aos";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../../../../node_modules/magnific-popup/dist/magnific-popup.css";
import BrandsMarqueSection from "../../../common/BrandsMarqueSection";
import Footer from "../../../common/Footer";
import Header from "../../../common/Header";
import Loader from "../../../common/Loader";
import ProgressCircle from "../../../common/ProgressCircle";
import TextMarqueSection from "../../../common/TextMarqueSection";

const ServicesPageThree = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  // Service data with updated content and Pexels images
  const services = [
    {
      id: 1,
      number: "01",
      title: "Branding Design",
      description:
        "Crafting unique brand identities with logos, color schemes, and visual strategies that resonate with your audience and elevate your business.",
      image:
        "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/3184298/pexels-photo-3184298.jpeg",
    },
    {
      id: 2,
      number: "02",
      title: "Web Development",
      description:
        "Building responsive, high-performance websites using modern technologies to drive engagement and meet your business goals.",
      image:
        "https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/1181359/pexels-photo-1181359.jpeg",
    },
    {
      id: 3,
      number: "03",
      title: "Content Marketing",
      description:
        "Developing strategic content plans to boost brand visibility, engage audiences, and drive conversions through compelling storytelling.",
      image:
        "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg",
    },
    {
      id: 4,
      number: "04",
      title: "Digital Marketing",
      description:
        "Maximizing ROI with tailored SEO, PPC, and email marketing campaigns designed to grow your online presence and revenue.",
      image:
        "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg",
    },
    {
      id: 5,
      number: "05",
      title: "Social Advertising",
      description:
        "Creating targeted social media ad campaigns to increase engagement, build brand loyalty, and drive conversions across platforms.",
      image: "https://images.pexels.com/photos/267350/pexels-photo-267350.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg",
    },
    {
      id: 6,
      number: "06",
      title: "Illustration Modelling",
      description:
        "Designing custom illustrations and 3D models to enhance your brand’s visual storytelling and create memorable user experiences.",
      image:
        "https://images.pexels.com/photos/3184293/pexels-photo-3184293.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/3184296/pexels-photo-3184296.jpeg",
    },
    {
      id: 7,
      number: "07",
      title: "Mobile Solutions",
      description:
        "Developing intuitive mobile apps for iOS and Android, delivering seamless functionality and user-friendly experiences.",
      image:
        "https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg",
    },
    {
      id: 8,
      number: "08",
      title: "Product Design",
      description:
        "Creating user-centric product designs that blend aesthetic appeal with functionality to meet market demands.",
      image:
        "https://images.pexels.com/photos/3184296/pexels-photo-3184296.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/3184293/pexels-photo-3184293.jpeg",
    },
    {
      id: 9,
      number: "09",
      title: "UI/UX Experience",
      description:
        "Designing intuitive, user-friendly interfaces to enhance customer satisfaction and streamline digital interactions.",
      image:
        "https://images.pexels.com/photos/1181359/pexels-photo-1181359.jpeg",
      hoverImage:
        "https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg",
    },
  ];

  // Hover styles for service cards
  // const hoverStyles = services
  //   .map(
  //     (service) => `
  //     #services-grid-main${service.id}:hover {
  //       background-image: linear-gradient(
  //         359deg,
  //         rgba(0, 0, 0, 0.56) 11.4%,
  //         rgba(0, 0, 0, 0.56) 70.2%
  //       ),
  //       url("${service.hoverImage}");
  //       background-size: cover;
  //       background-position: center;
  //       border: 2px solid #fff;
  //       border-radius: 0;
  //     }
  //   `
  //   )
  //   .join("");

  return (
    <>
      <Helmet>
        <title>Services | Marichi Tech AI</title>
        <meta
          name="description"
          content="Discover our full range of IT services including web apps, mobile development, and cloud solutions."
        />
        <meta
          name="keywords"
          content="IT services, software development, mobile apps, cloud solutions"
        />
        <meta property="og:title" content="Services | Marichi Tech AI" />
        <meta
          property="og:description"
          content="We provide scalable and robust IT solutions tailored for your business."
        />
        <meta
          property="og:image"
          content="https://example.com/services-og-image.jpg"
        />
      </Helmet>

      <Loader />
      <div className="site_contain">
        {/* <style>{hoverStyles}</style> */}
        {/* Header */}
        <Header />

        {/* Hero Section */}
        <section
          className="single-blog2-section-main overflow-hidden"
          id="main"
          style={{
            backgroundImage: `linear-gradient(
              359deg,
              rgba(0, 0, 0, 0.56) 11.4%,
              rgba(0, 0, 0, 0.56) 70.2%
            ),
            url("https://images.pexels.com/photos/3183183/pexels-photo-3183183.jpeg")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top center",
            backgroundSize: "cover",
            width: "100%",
            padding: "100px 0",
          }}
        >
          <div className="container">
            <p className="main-text" data-aos="fade-down">
              Creative Solutions
            </p>
            <h1 className="JessicaBiogi blog2-main-text" data-aos="fade-down">
              Explore Our Services
            </h1>
            <nav aria-label="breadcrumb" id="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item" aria-current="page">
                  <Link to="/services">Services</Link>
                </li>
              </ol>
            </nav>
          </div>
        </section>

        {/* Services Grid */}
        <section className="section-three overflow-hidden">
          <div className="container">
            <div className="row services-row-main">
              {services.map((service) => (
                <div
                  key={service.id}
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-6"
                >
                  <div
                    className="services-grid-main"
                    // id={`services-grid-main${service.id}`}
                    // data-aos="fade-up"
                    style={{
                      backgroundColor: "#1f2937",
                      borderRadius: "12px",
                      padding: "20px",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {/* <img
                      src={service.image || ""}
                      alt={service.title}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        marginBottom: "16px",
                      }}
                    /> */}
                    <p
                      className="number-services"
                      style={{
                        fontSize: "18px",
                        color: "white",
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      {service.number}
                    </p>
                    <h2
                      className="branding-design-text"
                      style={{
                        fontSize: "24px",
                        color: "white",
                        fontWeight: "600",
                        marginBottom: "12px",
                        lineHeight: "1.4",
                      }}
                    >
                      {service.title}
                    </h2>
                    <p
                      className="fule"
                      style={{
                        fontSize: "16px",
                        color: "white",
                        lineHeight: "1.7",
                        marginBottom: "16px",
                      }}
                    >
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Video Section */}
        <div
          className="services-video"
          style={{
            backgroundImage: `linear-gradient(
              359deg,
              rgba(0, 0, 0, 0.56) 11.4%,
              rgba(0, 0, 0, 0.56) 70.2%
            ),
            url("https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg")`,
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            height: "500px",
            position: "relative",
          }}
        >
          <div className="container"></div>
        </div>

        {/* Brands Marquee */}
        <BrandsMarqueSection />
        {/* Text Marquee */}
        <TextMarqueSection />
        {/* Footer */}
        <Footer />
        {/* Progress Circle */}
        <ProgressCircle />
      </div>
    </>
  );
};

export default ServicesPageThree;
